import * as angular from 'angular';

import { ComponentDefinition, WidgetValues, TagDateValue, ErrorLevel } from '../../models/index';
import { DoughnutChartOptions } from '../../framework/charting/charts/DoughnutChart/DoughnutChart.options';
import { mapSeries } from '../chartByIdentifier/mapSeries';
import { IExportToCsvService } from '../../services';
import { WideError } from '../../common/';
import { DoughnutChartWidget } from './doughnutChart.widget';

class DoughnutChartWidgetController implements angular.IComponentController {
    data: TagDateValue[] = [];
    id: string;
    isBound: boolean;
    options: DoughnutChartOptions;
    series: any[] = [];

    readonly boundData: WidgetValues;
    readonly boundSeries: any[] = []; // How is this not easier to type?
    readonly item: DoughnutChartWidget;
    readonly ratio: number;

    static $inject = [
        'exportToCsvService'
    ];
    constructor(
        private _exportToCsvService: IExportToCsvService
    ) {
    }

    $onInit() {
        const dataFormat = {
            label: d => d.builtName,
            identifier: d => d.valueType + d.guid,
            value: d => d.value
        };
        if (this.item && this.item.configuration) {
            const opt = this.item.configuration.options as any;
            opt.dataFormat = dataFormat;
            this.options = opt;
            this.item.exportToCsv = () => this._exportToCsvService.exportAggregatedToCsv(this.series, this.boundData.aggregatedValue, this.item.name);
        }
        this.series = this.series || [];
        this.data = this.data || [];
        this.refresh();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['item'] && changesObj['item'].currentValue) {
            this.id = 'doughnut' + this.item.guid;
        }
        if (changesObj['boundData'] && changesObj['boundData'].currentValue) {
            this.data = this.boundData.aggregatedValue || [];
        }
        this.refresh();
    }

    private refresh() {
        if (this.boundSeries && this.boundData) {
            const series = mapSeries(this.boundSeries, this.boundData.aggregatedValue, this.item, this.options);
            series.filter(s => !!s.attributes).forEach(s => s.attributes.placement = 'left');
            this.series = series;
            const values = this.data.map(d => d.value);
            if (values.filter(d => d > 0).length && values.filter(d => d < 0).length) {
                this.item.setError(new WideError(ErrorLevel.Warning, 'Positive and negative values are currently displayed. Chart may be inconsistent.'));
            } else {
                this.item.setError(null);

            }
        }
    }
}

export const wtDoughnutChartWidget: ComponentDefinition = {
    componentId: 'wtDoughnutChartWidget',
    controller: DoughnutChartWidgetController,
    template: require('./doughnutChartWidget.component.html'),
    controllerAs: 'vm',
    bindings: {
        boundData: '<',
        boundSeries: '<',
        item: '<',
        ratio: '<?'
    }
};